import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useCompanyStore} from "@domains/settings/stores/company.store";
import {useWorkspaceStore} from "@shared/stores/workspace.store";

export const getCompanyInfoResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

    const companyStore = useCompanyStore();
    const wsStore = useWorkspaceStore();
    const workspaceId = wsStore.getSelectedWorkspaceId;

    companyStore.loadCompanyInfo({workspaceId}).then(() => next())

};
